export const STREET = 'street';
export const BOULEVARD = 'boulevard';
export const PROSPECT = 'prospect';
export const LANE = 'lane';
export const AREA = 'area';
